import _assertThisInitialized from '@babel/runtime/helpers/assertThisInitialized';
import _inheritsLoose from '@babel/runtime/helpers/inheritsLoose';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { mergeStyles, validate, containsUrl, normalizeUrl, GlobalContext } from 'wix-rich-content-common';
import pluginHtmlSchema from 'wix-rich-content-common/dist/statics/schemas/plugin-html.schema.json';
import { I as INIT_WIDTH, a as INIT_HEIGHT, S as SRC_TYPE_HTML, b as SRC_TYPE_URL } from './viewer-loadable2.js';
export { d as defaults } from './viewer-loadable2.js';
import { h as htmlFixer, a as htmlComponentStyles, I as IframeHtml, b as IframeUrl } from './htmlFixer.js';
import '@loadable/component';
import 'ricos-types';

var __defProp = Object.defineProperty;
var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __publicField = function __publicField(obj, key, value) {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
var getPageURL = function getPageURL(siteDomain) {
  if (!siteDomain) {
    return;
  }
  var regex = /http.+com/gm;
  var res = regex.exec(siteDomain);
  if (res) {
    return res[0];
  }
  return res;
};
var HtmlComponent = /*#__PURE__*/function (_Component) {
  _inheritsLoose(HtmlComponent, _Component);
  function HtmlComponent() {
    var _this;
    _this = _Component.apply(this, arguments) || this;
    __publicField(_assertThisInitialized(_this), "state", {
      siteDomain: void 0
    });
    __publicField(_assertThisInitialized(_this), "setHeight", function (iframeHeight) {
      var _a;
      if (iframeHeight > 0 && iframeHeight !== _this.state.iframeHeight) {
        _this.setState({
          iframeHeight: iframeHeight
        });
        (_a = _this.props.store) == null ? void 0 : _a.update("componentData", {
          config: {
            height: iframeHeight
          }
        });
      }
    });
    __publicField(_assertThisInitialized(_this), "getIframeHeight", function () {
      var _this$props = _this.props,
        _this$props$settings = _this$props.settings;
      _this$props$settings = _this$props$settings === void 0 ? {} : _this$props$settings;
      var height = _this$props$settings.height,
        config = _this$props.componentData.config;
      var iframeHeight = _this.state.iframeHeight;
      var maxDiff = Math.min(50, _this.state.iframeHeight * 0.1);
      var normalizedHeight = iframeHeight;
      if (config.height) {
        normalizedHeight = iframeHeight && config.height < iframeHeight && config.height + maxDiff > iframeHeight ? iframeHeight : config.height;
      }
      return normalizedHeight || height || INIT_HEIGHT;
    });
    return _this;
  }
  var _proto = HtmlComponent.prototype;
  _proto.componentDidMount = function componentDidMount() {
    var _this$props2 = this.props,
      config = _this$props2.componentData.config,
      _this$props2$settings = _this$props2.settings,
      settings = _this$props2$settings === void 0 ? {} : _this$props2$settings;
    var width = settings.width,
      height = settings.height,
      siteDomain = settings.siteDomain;
    if (!config.width) {
      if (width) {
        config.width = width;
      } else if (this.element) {
        config.width = this.element.getBoundingClientRect().width;
      } else {
        config.width = INIT_WIDTH;
      }
    }
    if (!config.height) {
      config.height = height || INIT_HEIGHT;
    }
    this.setState({
      siteDomain: siteDomain
    });
  };
  HtmlComponent.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
    var componentData = props.componentData;
    if (componentData.srcType === "html") {
      var pageURL = getPageURL(state.siteDomain);
      return {
        html: htmlFixer(componentData.src, pageURL)
      };
    }
  };
  _proto.render = function render() {
    var _this2 = this;
    var _a;
    var html = this.state.html;
    var _this$props3 = this.props,
      iframeSandboxDomain = _this$props3.iframeSandboxDomain,
      theme = _this$props3.theme,
      componentData = _this$props3.componentData,
      _this$props3$settings = _this$props3.settings;
    _this$props3$settings = _this$props3$settings === void 0 ? {} : _this$props3$settings;
    var width = _this$props3$settings.width,
      isViewer = _this$props3.isViewer;
    this.styles = this.styles || mergeStyles({
      styles: htmlComponentStyles,
      theme: theme
    });
    validate(componentData, pluginHtmlSchema);
    var src = componentData.src,
      srcType = componentData.srcType,
      _componentData$config = componentData.config;
    _componentData$config = _componentData$config === void 0 ? {} : _componentData$config;
    var currentWidth = _componentData$config.width;
    var style = {
      width: this.props.isMobile ? "auto" : currentWidth || width || INIT_WIDTH,
      height: this.getIframeHeight(),
      maxHeight: this.state.iframeHeight
    };
    var experiments = this.props.experiments || this.context.experiments;
    return /* @__PURE__ */React.createElement("div", {
      className: this.styles.htmlComponent,
      ref: function ref(_ref) {
        return _this2.element = _ref;
      },
      style: style,
      "data-hook": "HtmlComponent"
    }, srcType === SRC_TYPE_HTML && src && /* @__PURE__ */React.createElement(IframeHtml, {
      iframeSandboxDomain: iframeSandboxDomain || ((_a = experiments.forceIframeSandboxDomain) == null ? void 0 : _a.enabled) && "https://www.filesusr.com",
      key: SRC_TYPE_HTML,
      tabIndex: 0,
      html: html,
      onHeightChange: this.setHeight,
      isViewer: isViewer
    }), srcType === SRC_TYPE_URL && containsUrl(src) && /* @__PURE__ */React.createElement(IframeUrl, {
      key: SRC_TYPE_URL,
      tabIndex: 0,
      src: normalizeUrl(src),
      isViewer: isViewer
    }), !src && !containsUrl(src) && /* @__PURE__ */React.createElement("div", {
      className: this.styles.htmlComponent_placeholder
    }));
  };
  return HtmlComponent;
}(Component);
__publicField(HtmlComponent, "contextType", GlobalContext);
HtmlComponent.propTypes = {
  componentData: PropTypes.object.isRequired,
  blockProps: PropTypes.object,
  className: PropTypes.string,
  settings: PropTypes.shape({
    width: PropTypes.number,
    minWidth: PropTypes.number,
    maxWidth: PropTypes.number,
    height: PropTypes.number,
    minHeight: PropTypes.number,
    maxHeight: PropTypes.number
  }).isRequired,
  store: PropTypes.object,
  block: PropTypes.object,
  siteDomain: PropTypes.string,
  theme: PropTypes.object.isRequired,
  isMobile: PropTypes.bool.isRequired,
  iframeSandboxDomain: PropTypes.string,
  experiments: PropTypes.object,
  isViewer: PropTypes.bool
};

export { HtmlComponent as Component, HtmlComponent as default };

import 'wix-rich-content-plugin-html/dist/loadable/viewer/es/styles.viewer.min.global.css'